import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';

function getIsContestAgainstTheSpreadEnabled(contest: FullContest | Contest) {
  return contest?.settings?.teamBasedScoringOptions?.option === 'AGAINST_THE_SPREAD';
}

export default getIsContestAgainstTheSpreadEnabled;
